export default "__VITE_ASSET__d8e4a1dd__"